export default __webpack_public_path__ + "static/media/group.ca03e58b.svg";